import React, { useState } from 'react';
import { Toaster } from 'react-hot-toast';
import LoadingTables from '../../../components/global/LoadingTables';
import Nav from '../../../components/specific/Navigation';
import Filter from '../../../components/specific/Lugar/Filter';
import TableLugar from '../../../components/specific/Lugar/Table';
import PageHeading from '../../../components/global/PageHeading';
import { ButtonTable } from '../../../components/global/Styles/buttons';
import { TitlesTables } from '../../../components/global/Styles/titles';
import ModalCrearLugar from '../../../components/specific/Lugar/ModalCrearLugar';

const ViewLugar = (props) => {
  const { loadingTables, handleDepurar, handleAddLugar } = props.actions;

  const { mostrarModal, setMostrarModal } = props.modal;

  return (
    <div className="flex max-h-screen min-h-screen flex-col overflow-hidden ">
      <Nav />
      <Toaster
        toastOptions={{
          className: 'bg-gray-500 p-2 rounded-md text-white font-bold text-sm ',
        }}
      />

      <div className="flex flex-grow flex-col overflow-hidden ">
        <div className="m-2 flex flex-grow flex-col overflow-hidden   ">
          <div className="flex ">
            <TitlesTables>LUGARES - TARIFAS</TitlesTables>
            <div className="flex-auto"></div>
            <Filter
              endPoint={props.endPoint}
              data={props.data}
            />
            <ButtonTable onClick={handleDepurar}>Depurar</ButtonTable>
            <ButtonTable
              className="ml-2"
              onClick={handleAddLugar}>
              Agregar
            </ButtonTable>
          </div>

          {loadingTables && <LoadingTables />}
          <TableLugar
            actions={props.actions}
            data={props.data}
          />
          {mostrarModal && (
            <ModalCrearLugar
              onClose={() => setMostrarModal(false)}
              data={props.data}
              endPoint={props.endPoint}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewLugar;
